import { Download } from "lucide-react";
import { Modal } from "@/components/ui/Modal";
import { Button } from "@/components/ui/Button";
import { solicitacaoAnexoUrl } from "@/services/solicitacaoPagamento";

type AnexoKind = "image" | "pdf" | "other";

function anexoKind(fileName: string): AnexoKind {
  const ext = fileName.split(".").pop()?.toLowerCase() ?? "";
  if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
  if (ext === "pdf") return "pdf";
  return "other";
}

interface Props {
  open: boolean;
  onClose: () => void;
  solicitacaoId: string;
  fileName: string;
}

export function SolicitacaoPagamentoAnexoModal({
  open,
  onClose,
  solicitacaoId,
  fileName,
}: Props) {
  const url = solicitacaoAnexoUrl(solicitacaoId);
  const kind = anexoKind(fileName);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={fileName}
      size="lg"
      footer={
        <div className="flex justify-end">
          <Button
            variant="secondary"
            size="sm"
            leftIcon={<Download className="w-4 h-4" />}
            onClick={() => {
              const a = document.createElement("a");
              a.href = url;
              a.download = fileName;
              a.click();
            }}
          >
            Baixar arquivo
          </Button>
        </div>
      }
    >
      <div className="min-h-[240px] flex items-center justify-center">
        {kind === "image" && (
          <img
            src={url}
            alt={fileName}
            className="max-h-[70vh] max-w-full rounded-lg object-contain mx-auto"
          />
        )}
        {kind === "pdf" && (
          <iframe
            src={url}
            title={fileName}
            className="w-full h-[70vh] rounded-lg border border-slate-200 bg-slate-50"
          />
        )}
        {kind === "other" && (
          <p className="text-sm text-slate-600 text-center px-4">
            Visualização indisponível para este tipo de arquivo. Use o botão abaixo para baixar.
          </p>
        )}
      </div>
    </Modal>
  );
}
